import {Inject, Injectable} from '@angular/core';
import {
  RestService,
  RestSimpleResponseParser,
  RestYiiFilterService,
  RestYiiPagination,
  RestYiiSort
} from 'gelios-ng-admin-components';
import {HttpClient} from '@angular/common/http';
import {ProjectCountryModel} from './project-country.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectCountryService extends RestService <ProjectCountryModel> {

  public get url(): string {
    return this.environmentApiBasepoint + 'project-country';
  }

  constructor(
    protected http: HttpClient,
    protected _filter: RestYiiFilterService,
    protected _sort: RestYiiSort,
    protected _pagination: RestYiiPagination,
    protected _parser: RestSimpleResponseParser,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string
  ) {
    super(http, _filter, _sort, _pagination, _parser, environmentVersion, environmentApiBasepoint);
    this.fields = [
      'id', 'name', 'project.custom_name', 'project.admin.login',
      'country_code', 'booking_timeout_seconds', 'acquirer.name',
      'insuranceProvider.name',
    ].join(',');
    this.expand = [
      'project',
      'project.admin',
      'acquirer',
      'insuranceProvider',
      'business_logic_custom_names'
    ].join(',');
    this._filter.searchModelName = 'ProjectCountrySearch';
  }
}
